import { BoxesIcon } from "lucide-react";

export const Logo = (props: React.ComponentProps<typeof BoxesIcon>) => {
	return <BoxesIcon {...props} />;
};
